<template>
    <b-modal v-model="show" title="БИНО ТУРИ">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 pl-0">
                    <div class="form-check form-check-radio pull-left pl-0">
                        <label class="form-check-label">
                            <input class="form-check-input"
                                   type="radio" value="Notorious"
                                   v-model="data.category">
                            <span class="form-check-sign"></span>
                            Нотурар
                        </label>
                    </div>
                    <div class="form-check form-check-radio pull-left">
                        <label class="form-check-label">
                            <input class="form-check-input" type="radio" value="Residential"
                                   v-model="data.category">
                            <span class="form-check-sign"></span>
                            Турар
                        </label>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label>Код <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.code"
                                :class="{'is-invalid': $v.data.code.$error}"
                                @blur="$v.data.code.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.code.$error">{{$t("realEstate.validation.cadastreSectionEdit.code")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Текст <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.name"
                                :class="{'is-invalid': $v.data.name.$error}"
                                @blur="$v.data.name.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.name.$error">{{$t("realEstate.validation.cadastreSectionEdit.nameUz")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Текст(ru) <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.nameRu"
                                :class="{'is-invalid': $v.data.nameRu.$error}"
                                @blur="$v.data.nameRu.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.nameRu.$error">{{$t("realEstate.validation.cadastreSectionEdit.nameRu")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Китоб <span class="red">*</span></label>
                        <numeric-input
                                v-model="data.book"
                        ></numeric-input>
                    </div>
                    <div class="form-check pl-0 checkbox-inline">
                        <label class="form-check-label"
                               style="padding-left:22px !important">
                            <input class="form-check-input" type="checkbox"
                                   v-model="data.generalCategory"
                            >
                            <span class="form-check-sign"></span>
                            Умумий категория
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save" v-if="hasPermission('SETTINGS_CAD_SECTION_ADD')">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import {numericTypes} from '@/shared/constants/mask'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '../../../shared/utils';
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: "CadastreSectionEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                numericTypes: numericTypes,
                data: {
                    category: 'Notorious',
                    code: '',
                    name: '',
                    nameRu: '',
                    book: 0,
                    generalCategory: false
                }
            }
        },
        validations: {
            data:{
                code:{
                    required
                },
                name:{
                    required
                },
                nameRu: {
                    required
                }
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;

                this.$http.post('cadastre/section', this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('cadastreSectionChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            }
        },
        created() {
            this.$eventBus.$on('showCadastreSectionEditModal', (data) => {
                if (data) {
                    this.data = clone(data);
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>
